import { BasicContent } from './BasicContent';
import RichText from './RichText';
import AtticatCalculator from '../../composites/Atticat/AtticatCalculator';

const CMSAtticatCalculator = ({ ...content }) => (
  <>
    <BasicContent {...content.copy} />
    <AtticatCalculator />
    <RichText content={content.footnotes} />
  </>
);

export default CMSAtticatCalculator;
